import { RadioGroupProps } from '../../types/RadioGroupProps';
export const RadioGroup = ({ groupHeading, children }: RadioGroupProps) => {
  return (
    <div className='mb-8'>
      <h1 className='font-bold mb-4'>{groupHeading}</h1>
      <div className='flex flex-col gap-2'>{children}</div>
    </div>
  );
};
